import React from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import { Download } from "../../../common/js/icons";
import { docTypeIcons } from "./documentTypes";
import get from "lodash/get";

const AttachmentCell = styled(TableCell)({
    fontSize: 14,
});

const Sortable = styled("span")({
    paddingRight: "5px",
    paddingBottom: "3px",
});

const DownloadDiv = styled("div")({
    cursor: "pointer",
    float: "right",
});

const MissingDocs = styled(TableCell)({
    color: "red",
});

const AttachmentWarning = styled(TableCell)({
    fontSize: 14,
    color: "red",
});

const DocumentListViewOnly = (props) => {
    const {
        open,
        docMenuKey,
        anchorEl,
        savedDocuments,
        missingRequiredDocuments,
        handleMenuClose,
        handlePreviewDocument,
        handleDownloadDocument,
        handleOpenDocumentMenu,
        includeSource,
        downloadView,
        role,
    } = props;

    const columnDefs =
        includeSource === true
            ? [
                  { display: "Name", prop: "mediaAssetName" },
                  { display: "Document Source", prop: "ownerType" },
                  { display: "Document Type", prop: "mediaAssetType" },
                  { display: "Required" },
                  { display: "" },
              ]
            : [
                  { display: "Name", prop: "mediaAssetName" },
                  { display: "Document Type", prop: "mediaAssetType" },
                  { display: "" },
              ];
    return (
        <Table>
            <TableHead>
                <TableRow>
                    {columnDefs.map((x, i) => (
                        <TableCell key={`doc-head-${i}`}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <Sortable>{x.display}</Sortable>
                            </div>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {role !== "auditor" &&
                    missingRequiredDocuments.map((doc, i) => {
                        const { name, type } = doc;
                        return (
                            <TableRow key={`tr-missing-${i}`} data-testid= {`Missing-${name}`} >
                                <AttachmentWarning>
                                    <span>Missing Required Document - {name}</span>
                                </AttachmentWarning>
                                {includeSource === true && (
                                    <AttachmentWarning>
                                        <span>{type}</span>
                                    </AttachmentWarning>
                                )}
                                <MissingDocs>
                                    <div>{name}</div>
                                </MissingDocs>
                                <MissingDocs>Yes</MissingDocs>
                                <TableCell />
                            </TableRow>
                        );
                    })}
                {Object.keys(savedDocuments).map((x, i) => {
                    const document = savedDocuments[x];
                    const excludeDocTypeIds = [49, 50];
                    const docType = get(document, "documentType", "");
                    const docTypeId = get(docType, "documentTypeKey", "");
                    const docTypeName = get(docType, "name", "");
                    if (role === "auditor" && excludeDocTypeIds.includes(docTypeId)) {
                        return null;
                    }
                    return (
                        <TableRow key={`tr-doc-${i}`}>
                            <AttachmentCell>
                                {get(
                                    docTypeIcons,
                                    get(document, "mediaAssetName", " ")
                                        .split(".")
                                        .pop()
                                        .toLowerCase(),
                                    docTypeIcons["default"]
                                )()}
                                <span> {document["mediaAssetName"]}</span>
                            </AttachmentCell>
                            {includeSource === true && (
                                <AttachmentCell>
                                    <span> {document["ownerType"]}</span>
                                </AttachmentCell>
                            )}
                            <TableCell>
                                <div>{docTypeName}</div>
                            </TableCell>
                            <TableCell>{get(document, "required", "") ? "Yes" : "No"}</TableCell>
                            {downloadView === true ? (
                                <TableCell style={{ paddingRight: "0px" }}>
                                    <DownloadDiv onClick={() => handleDownloadDocument(document)}>
                                        <Download />
                                    </DownloadDiv>
                                </TableCell>
                            ) : (
                                <TableCell>
                                    <div>
                                        <IconButton
                                            disabled={false}
                                            aria-label="More"
                                            aria-owns={Boolean(document["anchorEl"]) ? `long-menu-${x}-${i}` : null}
                                            aria-haspopup="true"
                                            onClick={(e) => handleOpenDocumentMenu(x, e.currentTarget)}
                                        >
                                            <MoreVertIcon />
                                        </IconButton>
                                        <Menu
                                            id="long-menu"
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleMenuClose}
                                            PaperProps={{
                                                style: {
                                                    width: 200,
                                                },
                                            }}
                                        >
                                            <MenuItem
                                                onClick={() =>
                                                    handlePreviewDocument(get(document, "url", null), docMenuKey)
                                                }
                                            >
                                                Open in a new tab
                                            </MenuItem>
                                        </Menu>
                                    </div>
                                </TableCell>
                            )}
                        </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    );
};

export default DocumentListViewOnly;
